import stylesConfig from "../styles.config";

export const RadioStyle = {
  padding: "5px",
  display: "none",
  alignItems: "center",
  marginRight: "15px",
  textAlign: "center",
  content: "''",
  width: "15px",
  height: "15px",
  borderRadius: "25px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "0px -103px",
  backgroundColor: stylesConfig.colors.primaryAccentColorVariants.gray,
};

export const RadioStyleSelected = {
  ...RadioStyle,
};
